import { PromptForm } from './PromptForm'

export default PromptForm
